import { render, staticRenderFns } from "./ButtonLG.vue?vue&type=template&id=49ed664a&"
import script from "./ButtonLG.vue?vue&type=script&lang=js&"
export * from "./ButtonLG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports